<script setup lang="ts">
interface IPopupData {
  headerLeft?: string;
  sublineLeft?: string;
  textLeft?: string;
  buttonTextPhoneLeft?: string;
  phoneNumberLeft?: string;
  buttonTextInternLeft?: string;
  linkLeft?: { uri: { path: string }, domainUri: { path: string } };
  headerRight?: string;
  textRight?: string;
  buttonTextInternRight?: string;
  linkRight?: { uri: { path: string }, domainUri: { path: string } };
}

const props = defineProps<{ identifier: string }>();

const queryKey = `popup-data-${props.identifier}`;
const queryVars = { id: props.identifier };

const { data: popupData } = await useAsyncData(queryKey, async () => {
  const result = await useGraphqlQuery('popupByIdentifier', queryVars);
  const popupData: Partial<IPopupData> = result.data?.entityQuery?.items?.[0] ?? {};

  return {
    headerLeft: popupData.headerLeft ?? '',
    sublineLeft: popupData.sublineLeft ?? '',
    textLeft: popupData.textLeft ?? '',
    buttonTextPhoneLeft: popupData.buttonTextPhoneLeft ?? '',
    phoneNumberLeft: popupData.phoneNumberLeft ?? '',
    buttonTextInternLeft: popupData.buttonTextInternLeft ?? '',
    linkLeft: popupData.linkLeft?.domainUri?.path || popupData.linkLeft?.uri?.path || '',
    headerRight: popupData.headerRight ?? '',
    textRight: popupData.textRight ?? '',
    buttonTextInternRight: popupData.buttonTextInternRight ?? '',
    linkRight: popupData.linkRight?.domainUri?.path || popupData.linkRight?.uri?.path || '',
  }
});
</script>

<template>
  <div class="Popup">

    <div class="Popup__background"></div>

    <div class="Popup__close">
      <i class="fa-light fa-times"></i>
    </div>

    <div class="Popup__content">

      <div class="Popup__content__inner">

        <div class="etx-flex Flex gh-25 gv-25 tab-l:gv-0 av-stretch">
          <div class="etx-flex__item Flex__item tab-s:c-10 tab-l:c-6 tab-s:ml-1">

            <div class="etx-card Card bg-secondary move-up did-appear" data-angle-position="top-right"
              data-angle-color="orange">

              <div class="etx-card__item Card__item ph-150 pv-150">

                <div class="etx-text Text">
                  <p v-if="popupData?.headerLeft" class="font-h2">{{ popupData.headerLeft }}</p>
                  <p v-if="popupData?.sublineLeft" class="font-h2 alt">{{ popupData.sublineLeft }}</p>
                  <HelperHtmlRenderer v-if="popupData?.textLeft" :htmlContent="popupData.textLeft" />
                </div>

                <div class="etx-button-list ButtonList">

                  <a v-if="popupData?.buttonTextPhoneLeft && popupData?.phoneNumberLeft" class="etx-button Button focus"
                    :href="`tel:${popupData.phoneNumberLeft}`">
                    <div class="etx-button__icon Button__icon">
                      <i class="far fa-phone"></i>
                    </div>
                    <div class="etx-button__text Button__text">
                      <span>{{ popupData.buttonTextPhoneLeft }}</span>
                    </div>
                  </a>

                  <a v-if="popupData?.buttonTextInternLeft && popupData?.linkLeft"
                    class="etx-button Button minimal" :href="popupData.linkLeft">
                    <div class="etx-button__text Button__text">
                      <span>{{ popupData.buttonTextInternLeft }}</span>
                    </div>
                    <div class="etx-button__icon Button__icon">
                      <i class="far fa-long-arrow-right"></i>
                    </div>
                  </a>

                </div>

              </div>

            </div>

          </div>

          <div class="etx-flex__item Flex__item tab-s:c-10 tab-l:c-4 tab-s:ml-1 tab-l:ml-0">

            <div class="etx-card Card bg-secondary move-up did-appear" data-angle-position="top-right"
              data-angle-color="orange">

              <div class="etx-card__item Card__item ph-150 pv-150">

                <div class="etx-text Text">
                  <p v-if="popupData?.headerRight" class="font-h4 font-color-orange">{{ popupData.headerRight }}</p>
                  <HelperHtmlRenderer v-if="popupData?.textRight" :htmlContent="popupData.textRight" />
                </div>

                <div class="etx-button-list ButtonList">

                  <a v-if="popupData?.buttonTextInternRight && popupData?.linkRight"
                    class="etx-button Button minimal" :href="popupData.linkRight">
                    <div class="etx-button__text Button__text">
                      <span>{{ popupData.buttonTextInternRight }}</span>
                    </div>
                    <div class="etx-button__icon Button__icon">
                      <i class="far fa-long-arrow-right"></i>
                    </div>
                  </a>

                </div>

              </div>

            </div>

          </div>
        </div>

      </div>

    </div>

  </div>
</template>
